import { Article } from '@ninjacart/nc-nk-core';
import { Card, Image, Text, useTimeAgo, XStack, YStack } from '@ninjacart/nc-nk-ui';
import dynamic from 'next/dynamic';
import { memo } from 'react';
import { Link } from 'solito/link';
import { PodcastPlayer } from '@ninjacart/nc-nk-video';

const AudioPlayer = dynamic(
  () => import('../agriNewsAudio/audioPlayer').then((mod) => mod.default),
  {
    ssr: false,
  }
);

type AgriNewsListItemProps = {
  item: Article;
  index: number;
  isActive: boolean;
  onPressDetail: (item: Article, index: number) => void;
  currentPlayIndex: number;
  onAudioAutoScroll: (currentIndex: number) => void;
  setCurrentPlayIndex: React.Dispatch<React.SetStateAction<number>>;
};

// const AgriNewsListItem = memo(
//   function AgriNewsListItem({
//     item,
//     index,
//     isActive,
//     onPressDetail,
//     currentPlayIndex,
//     onAudioAutoScroll,
//     setCurrentPlayIndex,
//   }: AgriNewsListItemProps) {
//     return (
//       <Card backgroundColor="$cardbackground" borderRadius={10} padding={12} marginBottom={12}>
//         <XStack space="$3" alignItems="flex-start" onPress={() => onPressDetail(item, index)}>
//           <YStack flex={1}>
//             <Link href={`/newsDetail/${item?.id}`} shallow>
//               <Text fontSize={18} fontWeight="bold" color="$usertextColor" numberOfLines={3}>
//                 {item?.title}
//               </Text>
//             </Link>
//             <XStack
//               onPress={(e) => {
//                 e.stopPropagation();
//               }}
//             >
//               {item?.blob_url && (
//                 <AudioPlayer
//                   currentVisibleIndex={currentPlayIndex}
//                   index={index}
//                   blob_url={item?.blob_url}
//                   id={item?.id ?? ''}
//                   title={item?.title || ''}
//                   isMuteIconShow={true}
//                   onAudioComplete={() => onAudioAutoScroll(currentPlayIndex)}
//                   setCurrentPlayIndex={setCurrentPlayIndex}
//                   screenName="agriNews page"
//                   category={item?.category || ''}
//                 />
//               )}
//               {item.type === 'youtube-podcast-audio' && item.source_url && (
//                 <PodcastPlayer
//                   url={item.source_url}
//                   index={index}
//                   currentVisibleIndex={currentPlayIndex}
//                   id={item.id}
//                   isMuteIconShow={true}
//                   title={item.title}
//                   category={item.category}
//                   screenName="agriNews page"
//                   onAudioComplete={() => onAudioAutoScroll(currentPlayIndex)}
//                   setCurrentPlayIndex={setCurrentPlayIndex}
//                 />
//               )}
//             </XStack>

//             <Text
//               fontSize={14}
//               color="$bronzeText"
//               numberOfLines={2}
//               ellipsizeMode="tail"
//               marginTop={4}
//             >
//               {item?.desc ?? ''}
//             </Text>

//             <XStack marginTop={6} space="$2">
//               <Text fontSize={12} color="$bronzeText">
//                 स्रोत: {item?.source_name}
//               </Text>

//               <Text fontSize={12} color="$bronzeText">
//                 -
//               </Text>
//               <Text fontSize={12} color="$bronzeText">
//                 {item?.publishedAt && !isNaN(new Date(item.publishedAt).getTime())
//                   ? useTimeAgo(item.publishedAt)
//                   : ''}
//               </Text>
//             </XStack>
//           </YStack>

//           <YStack
//             width={120}
//             height={120}
//             borderRadius={12}
//             backgroundColor="$lightGrey"
//             alignItems="center"
//             justifyContent="center"
//             onPress={() => onPressDetail(item, index)}
//           >
//             <Image
//               source={{
//                 uri:
//                   item?.media?.[0]?.url ??
//                   'https://ninjakissan.s3.ap-south-1.amazonaws.com/banner/2025-07-01/kharif.jpg',
//               }}
//               width={120}
//               height={120}
//               borderRadius={12}
//               resizeMode="cover"
//             />
//           </YStack>
//         </XStack>
//       </Card>
//     );
//   },
//   (prev, next) => prev.item.id === next.item.id && prev.isActive === next.isActive
// );

function AgriNewsListItem({
  item,
  index,
  isActive,
  onPressDetail,
  currentPlayIndex,
  onAudioAutoScroll,
  setCurrentPlayIndex,
}: AgriNewsListItemProps) {
  return (
    <Card backgroundColor="$cardbackground" borderRadius={10} padding={12} marginBottom={12}>
      <XStack space="$3" alignItems="flex-start" onPress={() => onPressDetail(item, index)}>
        <YStack flex={1}>
          <Link href={`/newsDetail/${item?.id}`} shallow>
            <Text fontSize={18} fontWeight="bold" color="$usertextColor" numberOfLines={3}>
              {item?.title}
            </Text>
          </Link>
          <XStack
            onPress={(e) => {
              e.stopPropagation();
            }}
          >
            {item?.blob_url && (
              <AudioPlayer
                currentVisibleIndex={currentPlayIndex}
                index={index}
                blob_url={item?.blob_url}
                id={item?.id ?? ''}
                title={item?.title || ''}
                isMuteIconShow={true}
                onAudioComplete={() => onAudioAutoScroll(currentPlayIndex)}
                setCurrentPlayIndex={setCurrentPlayIndex}
                screenName="agriNews page"
                category={item?.category || ''}
              />
            )}
            {item.type === 'youtube-podcast-audio' && item.source_url && (
              <PodcastPlayer
                url={item.source_url}
                index={index}
                currentVisibleIndex={currentPlayIndex}
                id={item.id}
                isMuteIconShow={true}
                title={item.title}
                category={item.category}
                screenName="agriNews page"
                onAudioComplete={() => onAudioAutoScroll(currentPlayIndex)}
                setCurrentPlayIndex={setCurrentPlayIndex}
              />
            )}
          </XStack>

          <Text
            fontSize={14}
            color="$bronzeText"
            numberOfLines={2}
            ellipsizeMode="tail"
            marginTop={4}
          >
            {item?.desc ?? ''}
          </Text>

          <XStack marginTop={6} space="$2">
            <Text fontSize={12} color="$bronzeText">
              स्रोत: {item?.source_name}
            </Text>

            <Text fontSize={12} color="$bronzeText">
              -
            </Text>
            <Text fontSize={12} color="$bronzeText">
              {item?.publishedAt && !isNaN(new Date(item.publishedAt).getTime())
                ? useTimeAgo(item.publishedAt)
                : ''}
            </Text>
          </XStack>
        </YStack>

        <YStack
          width={120}
          height={120}
          borderRadius={12}
          backgroundColor="$lightGrey"
          alignItems="center"
          justifyContent="center"
          onPress={() => onPressDetail(item, index)}
        >
          <Image
            source={{
              uri:
                item?.media?.[0]?.url ??
                'https://ninjakissan.s3.ap-south-1.amazonaws.com/banner/2025-07-01/kharif.jpg',
            }}
            width={120}
            height={120}
            borderRadius={12}
            resizeMode="cover"
          />
        </YStack>
      </XStack>
    </Card>
  );
}

export default AgriNewsListItem;
